import { Component } from '@angular/core';
import { FormBuilder, FormGroup, FormGroupDirective, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs/internal/operators/take';
import { MatSnackBar } from '@angular/material/snack-bar';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SharedService } from '../../../../shared/services/shared.service';
import { environment } from '../../../../../environments/environment';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { UtilsService } from '../../../../shared/services/utils.service';
import { EmailControllerService } from 'api-notification';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonModule } from '@angular/common';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';

@Component({
	selector: 'app-landing-publish-form',
	standalone: true,
	imports: [
		CommonModule,
		MatCardModule,
		MatFormFieldModule,
		MatInputModule,
		TranslateModule,
		MatButtonModule,
		ReactiveFormsModule,
		MatProgressSpinnerModule,
		MatDatepickerModule,
		MatNativeDateModule,
	],
	templateUrl: './landing-publish-form.component.html',
	styleUrl: './landing-publish-form.component.scss',
})
export class LandingPublishFormComponent {
	resellerSettingsContext: any;
	mobileView = false;
	data: any = [];
	formGroup: FormGroup = new FormGroup({});

	apiLoading = {
		contactForm: false,
	};

	constructor(
		private fb: FormBuilder,
		private _snackBar: MatSnackBar,
		private sharedService: SharedService,
		private responsive: BreakpointObserver,
		private utils: UtilsService,
		private apiNotification: EmailControllerService,
		private translate: TranslateService
	) {
		this.sharedService.resellerSettingsContext.pipe(takeUntilDestroyed()).subscribe({
			next: response => {
				this.resellerSettingsContext = response;
				this.resellerSettingsContext.reseller = environment.reseller;
				this.data = this.resellerSettingsContext.publishForm.data;
			},
		});

		this.formGroup = this.fb.group({
			company: [, [Validators.required]],
			subject: [, [Validators.required]],
      deliveryDate: [, [Validators.required]],
      contactName: [, [Validators.required]],
			emailFrom: [, [Validators.required, Validators.pattern(this.utils.VALIDATION_PATTERNS.get('E_MAIL') || '')]],
			phone: [, [Validators.required]],
			message: [, [Validators.required]],
			reseller: this.resellerSettingsContext.reseller.name.toUpperCase(),
		});

		this.responsive
			.observe([Breakpoints.XSmall, Breakpoints.Small])
			.pipe(takeUntilDestroyed())
			.subscribe(result => {
				this.mobileView = false;

				if (result.matches) {
					this.mobileView = true;
				}
			});
	}

	sendMessage(formDirective: FormGroupDirective) {
		this.apiLoading.contactForm = true;
		this.apiNotification
			.sendContactInfoDataToReseller(this.formGroup.value)
			.pipe(take(1))
			.subscribe({
				next: () => {
					this.sharedService.showNotification.next({
						message: this.translate.instant('NOTIFICATIONS.ACTION_COMPLETE'),
						type: 'SUCCESS',
					});
					this.apiLoading.contactForm = false;
					this.formGroup.reset();
					if (formDirective) {
						formDirective.resetForm();
					}
					this.openSnackBar(this.translate.instant('NOTIFICATIONS.ACTION_COMPLETE'), 'OK');
				},
				error: () => {
					this.sharedService.showNotification.next({
						message: this.translate.instant('NOTIFICATIONS.ACTION_ERROR'),
						type: 'ERROR',
					});
					this.apiLoading.contactForm = false;
					this.openSnackBar(this.translate.instant('NOTIFICATIONS.ACTION_ERROR'), 'OK');
				},
			});
	}

	openSnackBar(message: string, action: string) {
		this._snackBar.open(message, action);
	}
}
